import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(true); // Default to true for demo

  useEffect(() => {
    // Check if user is already logged in on component mount
    const token = localStorage.getItem('authToken');
    if (token) {
      // Set default auth header for all requests
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      fetchCurrentUser();
    } else {
      // For development, use auto-auth-token to bypass authentication
      axios.defaults.headers.common['Authorization'] = 'Bearer auto-auth-token';
      setCurrentUser({
        id: 'dev-admin-001',
        email: 'dev-admin@gym.local',
        name: 'Dev Admin',
        role: 'admin'
      });
      setIsAuthenticated(true);
      setLoading(false);
    }
  }, []);

  const fetchCurrentUser = async () => {
    try {
      const response = await axios.get('/api/auth/user');
      setCurrentUser(response.data);
      setIsAuthenticated(true);
      setLoading(false);
    } catch (err) {
      setError('Failed to fetch user data');
      setIsAuthenticated(false);
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    setLoading(true);
    setError('');
    try {
      const response = await axios.post('/api/auth/login', { email, password });
      localStorage.setItem('authToken', response.data.token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
      setCurrentUser(response.data.user);
      setIsAuthenticated(true);
      setLoading(false);
      return true;
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
      setIsAuthenticated(false);
      setLoading(false);
      return false;
    }
  };

  const logout = async () => {
    try {
      await axios.post('/api/auth/logout');
      localStorage.removeItem('authToken');
      delete axios.defaults.headers.common['Authorization'];
      setCurrentUser(null);
      setIsAuthenticated(false);
    } catch (err) {
      console.error('Logout error:', err);
    }
  };

  const value = {
    currentUser,
    loading,
    error,
    isAuthenticated,
    login,
    logout,
    user: {
      name: 'Utilisateur Demo',
      email: 'demo@example.com',
      role: 'admin'
    }
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext; 